import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  accordionWrapper: {
    fontSize: '16px',
  },
  accordionTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxHeight: (props: { maxHeight: string }) => `${props.maxHeight}`,
    padding: '16px',
    background: colors.planningGridAccordionSumaryBg,
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
  },
  accordionTitleItens: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  description: {
    width: '100%',
    fontWeight: 'normal',
  },
  actionButtons: {
    display: 'flex',
  },
  toggleButton: {
    marginLeft: '32px',
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  toggleButtonClosed: {
    transform: 'rotate(180deg)',
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  accordionOpen: {
    height: 'auto',
    visibility: 'visible',
    transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  accordionClosed: {
    height: '0',
    display: 'none',
    transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  accordionBody: {
    padding: '16px',
  },
});

export default useStyles;
